// eslint-disable-next-line
/**
 * 存储格式, 统一JSON字符串
 * { data: Object | Array, t: timestamp, id:id}
 */
class NativeStorage {
    // constructor() {}
    static LOCAL_KEYS = {
        STORELIST: 'STORELIST',
    };
    /**
     * 单位ms, 统一过期时间5分钟
     */
    overTime = 5 * 60 * 1000
    time = (new Date()).getTime();
    initialized = false;
    init () {
        this.getTimeNow()
        this.initialized = true
    }
    /**
     * 更新缓存内容及时间
     * 增加更新使用同样方法
     */
    update (key, val, id, goods_id, spec_id) {
        this.getTimeNow()
        localStorage.setItem(NativeStorage.LOCAL_KEYS[key], JSON.stringify({
            data: val,
            id: id,
            goods_id,
            spec_id,
            t: this.time,
        }))
    }
    /**
     * 删除缓存
     */
    remove (key) {
        this.getTimeNow()
        localStorage.removeItem(NativeStorage.LOCAL_KEYS[key])
    }
    /**
     * 获取
     */
    getLocal (key, id, goods_id = '', spec_id = '') {
        this.getTimeNow()
        return new Promise((resolve, reject) => {
            try {
                const storage = JSON.parse(localStorage.getItem(NativeStorage.LOCAL_KEYS[key]))
                if (storage.t < this.time - this.overTime || Number(id) !== Number(storage.id) || Number(goods_id) !== Number(storage.goods_id) || Number(spec_id) !== Number(storage.spec_id)) {
                    resolve({})
                } else if (storage.data) {
                    resolve(storage.data)
                } else {
                    resolve({})
                }
            } catch (err) {
                resolve({})
            }
        })
    }
    // 最新时间
    getTimeNow () {
        this.time = (new Date()).getTime()
    }
}

export default NativeStorage
